export default __webpack_public_path__ + "static/media/blue-loader.f1f3e604.svg";